import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Observable } from "rxjs";
import { CaseInfo } from "../../cases/_types/case-info";
import { Contract } from "../../companies/_types/contract";
import { Business } from "../../business/_types/business";

@Injectable({
    providedIn: 'root',
})

export class PublicBusinessService extends Service<Business> {
  public override type = 'business';
  public override url = 'common/public/business'; 

  public override get(id: string): Observable<Business> {
    let url = this.getAPIUrl() + "/" + id;
    return this.http.get<Business>(url);
  }
}
